import { type CSSResultGroup, html, LitElement, unsafeCSS } from 'lit'
import { customElement } from 'lit/decorators.js'
import styles from './eco-suite-navbar-menu-header.scss?inline'

/**
 * @summary A header element displayed at the top of a navbar dropdown menu.
 * @tag eco-suite-navbar-menu-header
 * @slot [default] - Header text or content projected into the component.
 */
@customElement('eco-suite-navbar-menu-header')
export class EcoSuiteNavbarMenuHeader extends LitElement {
  static readonly styles: CSSResultGroup = [unsafeCSS(styles)]

  connectedCallback() {
    super.connectedCallback()
    // The header is only ever used inside a `role="menu"` (either rendered
    // by the menu itself or slotted into its default slot). The parent menu
    // provides the accessible name via `aria-label`, so the header is purely
    // decorative — `role="presentation"` keeps it from being an invalid
    // direct child of `role="menu"` (WCAG 1.3.1 / 4.1.2).
    this.setAttribute('role', 'presentation')
  }

  render() {
    return html`
      <slot></slot>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'eco-suite-navbar-menu-header': EcoSuiteNavbarMenuHeader
  }
}
